import { authedFetch } from '../hooks/useTelegram';

// API base — override with VITE_API_URL in .env for non-local builds.
const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000';

export const apiUrl = (path: string) => `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;

/** Authenticated API call (sends Telegram initData as the bearer credential). */
export async function api<T = unknown>(
  initData: string,
  path: string,
  init?: RequestInit,
): Promise<T> {
  const res = await authedFetch(initData, apiUrl(path), init);
  if (!res.ok) {
    let detail: unknown;
    try {
      detail = await res.json();
    } catch {
      detail = await res.text().catch(() => '');
    }
    const retryAfter = Number(res.headers.get('Retry-After'));
    if (
      Number.isFinite(retryAfter) &&
      retryAfter > 0 &&
      detail &&
      typeof detail === 'object' &&
      !Array.isArray(detail)
    ) {
      detail = { ...detail, retryAfter };
    }
    throw new Error(`API ${res.status} ${path}: ${JSON.stringify(detail)}`);
  }
  return res.json() as Promise<T>;
}
